import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const MoreFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      d="M9.57 3.31H5.2A1.89 1.89 0 0 0 3.31 5.2v4.37a1.89 1.89 0 0 0 1.89 1.89h4.37a1.89 1.89 0 0 0 1.89-1.89V5.2a1.89 1.89 0 0 0-1.89-1.89ZM9.57 12.54H5.2a1.89 1.89 0 0 0-1.89 1.89v4.37a1.89 1.89 0 0 0 1.89 1.89h4.37a1.89 1.89 0 0 0 1.89-1.89v-4.37a1.89 1.89 0 0 0-1.89-1.89ZM18.8 3.31h-4.37a1.89 1.89 0 0 0-1.89 1.89v4.37a1.89 1.89 0 0 0 1.89 1.89h4.37a1.89 1.89 0 0 0 1.89-1.89V5.2a1.89 1.89 0 0 0-1.89-1.89ZM18.8 12.54h-4.37a1.89 1.89 0 0 0-1.89 1.89v4.37a1.89 1.89 0 0 0 1.89 1.89h4.37a1.89 1.89 0 0 0 1.89-1.89v-4.37a1.89 1.89 0 0 0-1.89-1.89Z"
      fill={color}
    />
  </Svg>
)

export default MoreFilled
